import format from 'date-fns/format';
import {exclusionCategory} from './ExclusionCategoryEnum';
import {TrainTypeEnum} from './TrainTypeEnum';
import {BusMainTypeEnum} from './BusMainTypeEnum';

const dateFormat = 'd. M. yyyy';
const timeFormat = 'HH:mm';

export const extraordinaryPopupTemplate = ({
  name, perex, url, newsTypeTags, solutionTypeTags, date, icon, category
}) => {
  const nowTime = new Date().getTime();
  const isFeatureExclusion = category === exclusionCategory.EXCLUSIONS && nowTime < date;
  return `
<div class="map__popup__item">
  <div class="map__popup__info ${isFeatureExclusion ? 'map__popup__info--feature-exclusion' : `map__popup__info--${newsTypeTags[0].systemId}`}">
    ${category === exclusionCategory.EXTRAORDINARY ? `
      <svg class="svg-icon" aria-label="Upozornění"><use xlink:href="/ver/20200428134651/img/svg/svg-sprite.svg#alert"></use></svg>
    ` : ''}
    ${newsTypeTags[0].name}
  </div>

  <h3>${name}</h3>

  <dl>
  	${category !== exclusionCategory.EXTRAORDINARY ? `
       <dt>Datum:</dt>
    ` : ''}
    ${perex && `<dd>${perex}</dd>`}
  </dl>
  ${solutionTypeTags[0] && `
    <dl>
      <dt>Řešení výluky:</dt>
      <dd>${solutionTypeTags[0].name}</dd>
    </dl>
  `}
  <a class="btn" href="${url}">Detail</a>
</div>
`;
};

const trainPopupItemTemplate = ({
  trainNumber,
  trainDirectionText,
  stopId,
  time,
  delay,
  trainType
}, stationNameEnum) => {
  const formatedTime = format(new Date(time), timeFormat);
  const stopStationName = stationNameEnum[stopId];
  return `
<div class="map__popup__item map__popup__item--train">
  <div class="map__popup__info map__popup__info--train">
    ${TrainTypeEnum[trainType]}
  </div>
  <h3>Vlak: ${trainNumber}</h3>
  <dl>
    <dt>Cílová stanice vlaku</dt>
    <dd>${trainDirectionText}</dd>
  </dl>
    <dl>
    <dt>Potvrzená stanice:</dt>
    <dd>${stopStationName ? stopStationName : `Zjišťuje se (${stopId})`}</dd>
  </dl>
  <dl>
    <dt>${delay < 0 ? 'Náskok vlaku' : 'Předpokládané zpoždění'}:</dt>
    <dd> ${delay <= 0 ? 'Jede včas' : `${delay} min.`}</dd>
  </dl>
  <dl>
    <dt>Čas oznámení pozice:</dt>
    <dd>${formatedTime}</dd>
  </dl>
</div>
`;
};

export const trainPopupTemplate = (data, stationNameEnum) => {
  return `
  ${data.map((itemData, index) =>
    `
  ${trainPopupItemTemplate(itemData, stationNameEnum)}
`
  ).join('<hr />')}
  `;
};

const busPopupItemTemplate = ({
  delay,
  destinationName,
  lastStopName,
  linkNumber,
  linkNumberAlias,
  spz,
  state,
  type,
  updated
}) => {
  const formatedTime = format(new Date(updated), timeFormat);

  return `
<div class="map__popup__item">
  <dl>
    <dt>Číslo linky:</dt>
    <dd>${linkNumber}</dd>
  </dl>
  <dl>
    <dt>Cílová zastávka:</dt>
    <dd>${destinationName}</dd>
  </dl>
  <dl>
    <dt>RZ:</dt>
    <dd>${spz ? spz : ''}</dd>
  </dl>
  <dl>
    <dt>Čas poslední polohy:</dt>
    <dd>${formatedTime}</dd>
  </dl>
   <dl>
    <dt>Aktuální umístění:</dt>
    <dd>${state}</dd>
  </dl>
  <dl>
    <dt>${delay < 0 ? 'Náskok autobusu' : 'Poslední známé zpoždění'}:</dt>
    <dd> ${delay <= 0 ? 'Jede včas' : `${delay} min`}</dd>
  </dl>
   <dl>
    <dt>Následující zastávka:</dt>
    <dd>${lastStopName}</dd>
  </dl>
  <dl>
    <dt>Typ dopravy:</dt>
    <dd>${type}</dd>
  </dl>
</div>
`;
};

export const busPopupTemplate = (data) => {
  return `
  ${[data].map((itemData) =>
    `${busPopupItemTemplate(itemData)}`
  )}
  `;
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Map/mapTemplates.js